import React, { Component } from 'react';
import styled from 'styled-components';
import { ButtonVariations } from '../../SolvPatternLibrary/Button';
import { colors } from '../../../constants/colors';
import FileUpload from '../../SolvPatternLibrary/FileUpload';

const Root = styled.div.withConfig({ componentId: 'sc-19qpyp4-0' })`
  position: relative;
  width: 80px;
  height: 80px;
  margin: 5px;
  background-color: ${colors.theWhiteAlbum};
  border-radius: 20%;
  border: 1px dashed ${colors.blueMonday};
`;

const UploadAndScanButton = styled.div.withConfig({ componentId: 'sc-19qpyp4-1' })`
  margin-left: auto;
  margin-right: auto;
  width: 80px;
`;

const FileInput = styled(FileUpload).withConfig({ componentId: 'sc-19qpyp4-2' })`
  position: absolute;
  width: 80px;
  height: 80px;
  top: 0;
  left: 0;
  opacity: 0.01;
  border: none;
  z-index: 1;
  cursor: pointer;
  font-size: 0;
`;

const CameraIcon = styled.img.withConfig({ componentId: 'sc-19qpyp4-3' })`
  display: inline;
  width: 50px;
  height: 50px;
  margin: 10px 10px 10px 16px;
`;

type Props = {
  handleImageSelect?: (...args: any[]) => any;
};

class AddPhotoTile extends Component<Props> {
  render = () => (
    <Root>
      <FileInput
        accept={'image/*'}
        onChange={this.props.handleImageSelect}
        // @ts-expect-error
        text="Upload Photo"
        type="file"
      />
      {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'disableRipple' does not exist on type 'I... Remove this comment to see the full error message */}
      <UploadAndScanButton disableRipple>
        <CameraIcon src="/images/icons/camera_icon/blue_camera_plus.svg" />
      </UploadAndScanButton>
    </Root>
  );
}

export default AddPhotoTile;
